export function numFormatter(value, sign, displaySign) {
    const numFormatter = Intl.NumberFormat('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    return (displaySign ? (value.greaterThanOrEqualTo(0) ? '+' : '-') : '')
        + (sign === '$' ? '$' : '')
        + numFormatter.format(value.abs().toNumber())
        + (sign === '%' ? '%' : '');
}